import React from 'react'

export default function Light() {
  return (
    <div>
      Light
    </div>
  )
}
